import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { PaymentsNdcCommercialFaqPage } from 'src/app/model/page/group/faq/payments-ndc-commercial-faq-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-payments-ndc-commercial-faq-page',
  templateUrl: './payments-ndc-commercial-faq-page.component.html',
  styleUrls: ['./payments-ndc-commercial-faq-page.component.scss']
})
export class PaymentsNdcCommercialFaqPageComponent implements OnInit {
  param: string = '';
  paymentsPage: PaymentsNdcCommercialFaqPage = {} as PaymentsNdcCommercialFaqPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private activatedRoute: ActivatedRoute, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'faq-commercial-payments') {
        this.paymentsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.activatedRoute.params.subscribe((params) => (this.param = params['param']));

    this.paymentsPage.sections = [];
    this.paymentsPage.tableSection = [];

    const query = { 'fields.title': 'NDC Commercial FAQ#Payments' };
    this.contentfulService.getPageContentWithEntries(query).then((PaymentsNdcCommercialFaqPageEntries) => {
      this.mapBanner(PaymentsNdcCommercialFaqPageEntries);
      this.mapSections(PaymentsNdcCommercialFaqPageEntries);
      this.mapTableSection(PaymentsNdcCommercialFaqPageEntries);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
      this.paymentsPage.htmlTitle = linkItems[0].fields.htmlTitle;
    });
  }

  private mapBanner(paymentsPageEntries: Entry<any>[]) {
    paymentsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.paymentsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapSections(paymentsPageEntries: Entry<any>[]) {
    paymentsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
        this.paymentsPage.sectionsTopSection = this.paymentsPage.sections.filter((section) => GroupValidator.isTopSection(section.group));
        this.paymentsPage.sectionsMiddleSection = this.paymentsPage.sections.filter((section) => GroupValidator.isMiddleSection(section.group));
        this.paymentsPage.sectionsBottomSection = this.paymentsPage.sections.filter((section) => GroupValidator.isBottomSection(section.group));
      });

    this.paymentsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.paymentsPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      key: pageTitle
    });
    this.paymentsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(paymentsPageTableEntrySection: Entry<any>[]) {
    paymentsPageTableEntrySection
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
        this.paymentsPage.tableSectionTopTableSection = this.paymentsPage.tableSection.filter((tableSection) => GroupValidator.isTopTableSection(tableSection.group));
        this.paymentsPage.tableSectionMidddleTableSection = this.paymentsPage.tableSection.filter((tableSection) => GroupValidator.isMiddleTableSection(tableSection.group));
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {
    this.paymentsPage.tableSection.push({
      title: '',
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
  }
}
